


export type AuthorizationType = 'Default' | 'Absence';

export const AuthorizationType = {
    Default: 'Default' as AuthorizationType,
    Absence: 'Absence' as AuthorizationType
};

